// extracted by mini-css-extract-plugin
export default {"container":"style_container__aRgkx","number":"style_number__Fq1jn","text":"style_text__NQtUr"};